import Home from "./Home";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";

function Homenew() {
  return (
    <>
      <Home />
       <Section3 />
      <Section4 />
       <Section6 />
    </>
  );
}

export default Homenew;
